(function () {
  if (window.VellutoProductLoaded) return;
  window.VellutoProductLoaded = true;

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, format);
      } catch (error) {
        // Use the locale fallback below.
      }
    }

    var currency = 'EUR';
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      currency = window.Shopify.currency.active;
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', {
        style: 'currency',
        currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function reveal(scope) {
    var elements = scope.querySelectorAll('[data-vl-reveal]:not(.vl-is-visible)');

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('vl-is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vl-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -35px' });

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function initRecommendations(root) {
    var recommendations = root.querySelector('[data-vl-recommendations]');
    if (!recommendations || recommendations.dataset.loaded === 'true') return;

    var url = recommendations.dataset.url;
    if (!url) return;
    recommendations.dataset.loaded = 'true';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var incoming = documentFragment.querySelector('[data-vl-recommendations-inner]');
        var current = recommendations.querySelector('[data-vl-recommendations-inner]');
        if (!incoming || !current || !incoming.innerHTML.trim()) return;
        current.innerHTML = incoming.innerHTML;
        recommendations.hidden = false;
        reveal(recommendations);
      })
      .catch(function () {
        recommendations.hidden = true;
      });
  }

  function initLightbox(root) {
    var dialog = root.querySelector('[data-vl-lightbox]');
    var dialogImage = root.querySelector('[data-vl-lightbox-image]');
    if (!dialog || !dialogImage) return;

    root.querySelectorAll('[data-vl-pdp-zoom]').forEach(function (button) {
      button.addEventListener('click', function () {
        dialogImage.src = button.dataset.imageSrc || '';
        dialogImage.alt = button.dataset.imageAlt || '';
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });
    });

    var close = root.querySelector('[data-vl-lightbox-close]');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  function initSizeGuide(root) {
    var dialog = root.querySelector('[data-vl-size-guide]');
    var openButton = root.querySelector('[data-vl-size-guide-open]');
    if (!dialog || !openButton) return;

    function closeDialog() {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    }

    openButton.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });

    var closeButton = dialog.querySelector('[data-vl-size-guide-close]');
    if (closeButton) closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
  }

  function initWishlist(root) {
    var button = root.querySelector('[data-vl-wishlist]');
    if (!button) return;

    var key = 'velluto-favourite:' + (root.dataset.productUrl || window.location.pathname);
    var active = false;
    try {
      active = window.localStorage.getItem(key) === '1';
    } catch (error) {
      active = false;
    }

    function paint() {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Guardar nos favoritos');
    }

    paint();
    button.addEventListener('click', function () {
      active = !active;
      try {
        window.localStorage.setItem(key, active ? '1' : '0');
      } catch (error) {
        // The visual state still works when local storage is unavailable.
      }
      paint();
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.vlInitialized === 'true') return;
    root.dataset.vlInitialized = 'true';

    var dataElement = root.querySelector('[data-vl-product-data]');
    var productData;
    try {
      productData = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    var variants = productData.variants || [];
    var optionGroups = Array.from(root.querySelectorAll('[data-vl-option-index]'));
    var variantInput = root.querySelector('[data-vl-variant-id]');
    var addButton = root.querySelector('[data-vl-add-button]');
    var addText = root.querySelector('[data-vl-add-text]');
    var mobileButton = root.querySelector('[data-vl-mobile-add]');
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var installmentCount = Number(root.dataset.installmentCount || 6);
    var lowStockThreshold = Number(root.dataset.lowStockThreshold || 3);

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var selected = group.querySelector('[data-vl-option-value]:checked');
        return selected ? selected.value : null;
      });
    }

    function currentVariant() {
      if (!optionGroups.length) {
        return variants.find(function (variant) {
          return variantInput && String(variant.id) === String(variantInput.value);
        }) || variants[0];
      }

      var options = selectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return String(option) === String(options[index]);
        });
      });
    }

    function updateOptionAvailability() {
      var selected = selectedOptions();
      optionGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll('[data-vl-option-value]').forEach(function (input) {
          var possible = variants.some(function (variant) {
            if (!variant.available || String(variant.options[groupIndex]) !== String(input.value)) return false;
            return selected.every(function (value, optionIndex) {
              if (optionIndex === groupIndex || value === null) return true;
              return String(variant.options[optionIndex]) === String(value);
            });
          });
          input.disabled = !possible;
        });
      });
    }

    function updateStock(variant) {
      var stock = root.querySelector('[data-vl-stock]');
      var stockText = root.querySelector('[data-vl-stock-text]');
      if (!stock || !stockText) return;

      var text = 'Esgotado';
      stock.classList.toggle('is-sold-out', !variant || !variant.available);

      if (variant && variant.available) {
        if (variant.inventory_management && Number(variant.inventory_quantity) === 1) {
          text = 'Última unidade disponível';
        } else if (variant.inventory_management && Number(variant.inventory_quantity) > 1 && Number(variant.inventory_quantity) <= lowStockThreshold) {
          text = 'Restam apenas ' + variant.inventory_quantity + ' unidades';
        } else if (variant.inventory_management && Number(variant.inventory_quantity) <= 0) {
          text = 'Disponível por encomenda';
        } else {
          text = 'Disponível';
        }
      }

      stockText.textContent = text;
    }

    function updatePrice(variant) {
      if (!variant) return;
      var currentPrice = root.querySelector('[data-vl-current-price]');
      var comparePrice = root.querySelector('[data-vl-compare-price]');
      var discount = root.querySelector('[data-vl-discount]');
      var saving = root.querySelector('[data-vl-saving]');
      var installment = root.querySelector('[data-vl-installment]');
      var mobilePrice = root.querySelector('[data-vl-mobile-price]');
      var hasDiscount = Number(variant.compare_at_price) > Number(variant.price);

      if (currentPrice) currentPrice.textContent = formatMoney(variant.price, moneyFormat);
      if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price, moneyFormat);
      if (installment) installment.textContent = formatMoney(Math.round(Number(variant.price) / installmentCount), moneyFormat);

      if (comparePrice) {
        comparePrice.hidden = !hasDiscount;
        comparePrice.textContent = hasDiscount ? formatMoney(variant.compare_at_price, moneyFormat) : '';
      }

      if (discount) {
        discount.hidden = !hasDiscount;
        discount.textContent = hasDiscount
          ? '–' + Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price)) + '%'
          : '';
      }

      if (saving) {
        saving.hidden = !hasDiscount;
        saving.textContent = hasDiscount
          ? 'Poupa ' + formatMoney(Number(variant.compare_at_price) - Number(variant.price), moneyFormat)
          : '';
      }
    }

    function updateSku(variant) {
      var row = root.querySelector('[data-vl-sku-row]');
      var value = root.querySelector('[data-vl-sku]');
      if (!row || !value) return;
      row.hidden = !variant || !variant.sku;
      value.textContent = variant && variant.sku ? variant.sku : '';
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media_id || window.innerWidth >= 900) return;
      var media = root.querySelector('[data-vl-media-id="' + variant.featured_media_id + '"]');
      if (media && typeof media.scrollIntoView === 'function') {
        media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    function updateVariant() {
      updateOptionAvailability();
      var variant = currentVariant();
      var available = Boolean(variant && variant.available);

      if (variantInput) variantInput.value = variant ? variant.id : '';
      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = available ? 'Adicionar ao carrinho' : 'Esgotado';
      if (mobileButton) {
        mobileButton.disabled = !available;
        mobileButton.textContent = available ? 'Adicionar' : 'Esgotado';
      }

      updatePrice(variant);
      updateStock(variant);
      updateSku(variant);
      updateMedia(variant);

      if (variant && window.history && typeof window.history.replaceState === 'function') {
        var baseUrl = root.dataset.productUrl || window.location.pathname;
        window.history.replaceState({}, '', baseUrl + '?variant=' + variant.id);
      }
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('change', updateVariant);
    });

    if (mobileButton && addButton) {
      mobileButton.addEventListener('click', function () {
        if (!mobileButton.disabled) addButton.click();
      });
    }

    initWishlist(root);
    initLightbox(root);
    initSizeGuide(root);
    initRecommendations(root);
    updateVariant();
    reveal(root);
  }

  function init(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-vl-product-root]')) initProduct(target);
    target.querySelectorAll('[data-vl-product-root]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
